import React, { useState } from "react";
import L from "leaflet";

import { withSnackbar } from "notistack";
import { COMMON_JS } from "common/scripts";
import { Marker } from "react-leaflet";

const PieChartOnMap = (props: any) => {
  const { showCharts, setShowCharts } = props;

  const getChartsOnMap = (v) => {
    let chartMarker = null;
    const width = 200;
    const height = 200;
    const html = COMMON_JS.getSvgChartMarker({
      id: v.id,
      seg1: v.val1,
      seg2: v.val2,
      seg3: v.val3,
    });

    chartMarker = L.divIcon({
      html: html,
      iconSize: new L.Point(width, height),
      iconAnchor: null,
      popupAnchor: [0, -3],
      className: "mapMarker",
    });
    return chartMarker;
  };

  const chartData = [
    {
      val1: 30,
      val2: 10,
      val3: 0,
      lat: 12.4716,
      lng: 76.5946,
    },
    {
      val1: 50,
      val2: 10,
      val3: 90,
      lat: 12.9716,
      lng: 77.5946,
    },
    {
      val1: 10,
      val2: 20,
      val3: 30,
      lat: 11.9716,
      lng: 76.5946,
    },
    {
      val1: 90,
      val2: 10,
      val3: 1,
      lat: 10.9716,
      lng: 74.5946,
    },
  ];
  return (
    <>
      {/* showcharts insted of false to display charts (mock data) incomplete */}
      {false &&
        chartData &&
        chartData.map((t, i) => {
          return (
            <Marker
              position={{
                lat: t.lat,
                lng: t.lng,
              }}
              icon={getChartsOnMap(t)}
              key={"chart-" + i}
              className="mapMarker"
            ></Marker>
          );
        })}
    </>
  );
};

export default withSnackbar(PieChartOnMap);
